<div class="custom-multi-select form-field pb-0 mb-0" [class.open]="isOpen" (click)="$event.stopPropagation()">
    <!-- Label -->
    @if(label) {
    <label class="form-field__label">
      {{ label }}
      @if(required) {
      <span class="form-field__required">*</span>
      }
    </label>
    }
  
    <!-- Select box -->
    <div
    class="form-field__select  form-field__select--{{ size }}"
    [ngClass]="{
      'form-field__select--invalid': control?.touched && control?.invalid,
      'form-field__select--disabled': control?.disabled
    }"
    (click)="toggleDropdown($event)"
    [title]="title"
  >
    @if(values.length === 0) {
      <span class="form-field__placeholder">{{ placeholder }}</span>
    }
  
    @if(values.length > 0) {
      <div class="selected-tags">
        @for(opt of options; track opt.value) {
          @if(values.includes(opt.value)) {
          <span class="tag">
            {{ opt.label | titlecase }}
            <span class="remove" (click)="toggleOption(opt); $event.stopPropagation()">×</span>
          </span>
          }
        }
      </div>
    }
  
    <span class="arrow">&#9662;</span>
  </div>
  
  
    <!-- Dropdown list -->
    @if(isOpen) {
    <div class="form-field__dropdown" (click)="$event.stopPropagation()">
      @if(showSearch) {
      <div class="p-2">
        <input
          type="text"
          class="form-field__input"
          [(ngModel)]="searchTerm"
          (ngModelChange)="filterOptions()"
          placeholder="Search..."
          (click)="$event.stopPropagation()"
        />
      </div>
      }
  
      @for(opt of filteredOptions; track $index) {
      <div
        class="form-field__option"
        [class.selected]="isSelected(opt.value)"
        (click)="toggleOption(opt, $event)"
      >
        <input
          type="checkbox"
          [checked]="isSelected(opt.value)"
          (click)="toggleOption(opt, $event)"
        />
        <span>{{ opt.label | titlecase }}</span>
      </div>
      }
  
      @if(filteredOptions.length === 0) {
      <div class="form-field__no-results">No results found</div>
      }
    </div>
    }
  </div>
  
  @if(errorMessage) {
  <div class="form-field__error">{{ errorMessage }}</div>
  }
  